import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MybusinessNeedOffer} from 'components/my-business';
import title from 'constants/TitlePages.js';
import {BusinessLayout} from 'components/layouts/business';

class MybusinessNeedOfferPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.MybusinessNeedOfferPage;
  }

  render() {
    return (
      <MasterLayout>
        <BusinessLayout active="need-offer">
          <MybusinessNeedOffer params={this.props.match.params}/>
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default MybusinessNeedOfferPage;



// WEBPACK FOOTER //
// ./pages/need-offer/MybusinessNeedOfferPage.jsx